/* eslint-disable perfectionist/sort-enums */
export enum PublishTarget {
    // Local publish targets
    localEmail = 'local-email',
    localMedia = 'local-media',
    localPrint = 'local-print',

    // Email publish targets
    campaignMonitor = 'campaign-monitor',
    clubready = 'clubready',
    glofox = 'glofox',
    kite = 'kite',
    marianaTek = 'marianaTek',
    mindbody = 'mindbody',
    zenoti = 'zenoti',

    // Legacy social publish targets
    facebookPostLegacy = 'facebook-post-legacy',
    googleMyBusinessPostLegacy = 'google-my-business-post-legacy',
    instagramPostLegacy = 'instagram-post-legacy',
    instagramReelLegacy = 'instagram-reel-legacy',
    instagramStoryLegacy = 'instagram-story-legacy',
    linkedinPostLegacy = 'linkedin-post-legacy',

    // Social publish targets
    facebookPost = 'facebook-post',
    googleMyBusinessPost = 'google-my-business-post',
    instagramPost = 'instagram-post',
    instagramReel = 'instagram-reel',
    instagramStory = 'instagram-story',
    linkedinPost = 'linkedin-post',
}
